import { styled } from '@mui/material/styles'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { Colors } from '../../theme'

export const SelectorCard = styled('section')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginTop: '1.5rem',
  padding: '8px 8px 8px 10px',
  borderRadius: 16,
  background: Colors.WHITE,
  boxShadow: `0 10px 28px ${Colors.SHADOW_CARD}`,
}))

export const VehicleIcon = styled('span')(() => ({
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  width: 40,
  height: 40,
  borderRadius: 12,
  background: `linear-gradient(135deg, ${Colors.BG_START} 0%, ${Colors.BG_END} 100%)`,
  color: Colors.GREEN_BACKGROUND,
}))

export const VehicleSelect = styled(Select)(() => ({
  flex: 1,
  minWidth: 0,
  '& .MuiSelect-select': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '2px 32px 2px 0',
    textAlign: 'left',
  },
  '& .MuiSelect-icon': {
    right: 4,
    color: Colors.BG_START,
  },
}))

export const Caption = styled('span')(() => ({
  color: Colors.GRAY_TEXT,
  fontSize: '0.7rem',
  fontWeight: 600,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  lineHeight: 1.3,
}))

export const VehicleName = styled('span')(() => ({
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: Colors.BG_START,
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: 1.3,
}))

export const VehicleOption = styled(MenuItem)(() => ({
  gap: 12,
  minHeight: 48,
  fontWeight: 600,
  color: Colors.BG_START,
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
    background: Colors.GREEN_SELECTED,
  },
}))

export const OptionPlate = styled('span')(() => ({
  marginLeft: 'auto',
  color: Colors.GRAY_TEXT,
  fontSize: '0.8rem',
  fontWeight: 600,
}))
